import type { UserCommunication } from '@this+that/models';

import type { ComposeSnapshotIndexEntry } from './types';
import { resolveDraftCommunication } from '../../utils/userCommunicationHelpers';

const collectDraftIds = (uc: UserCommunication): Set<string> => {
  const ids = new Set<string>();
  if (uc.draftId) {
    ids.add(uc.draftId);
  }
  const nested = resolveDraftCommunication(uc)?.draftId;
  if (nested) {
    ids.add(nested);
  }
  uc.threadMessages?.forEach((message) => {
    if (message.draftId) {
      ids.add(message.draftId);
    }
  });
  return ids;
};

const collectMessageIds = (uc: UserCommunication): Set<string> => {
  const ids = new Set<string>();
  if (uc.messageId) {
    ids.add(uc.messageId);
  }
  uc.threadMessages?.forEach((message) => {
    if (message.messageId) {
      ids.add(message.messageId);
    }
  });
  return ids;
};

export const selectUnsavedSnapshotEntry = (
  entriesBySessionId: Record<string, ComposeSnapshotIndexEntry>,
  liveSessionIds: Record<string, true>,
  uc: UserCommunication,
): ComposeSnapshotIndexEntry | undefined => {
  const draftIds = collectDraftIds(uc);
  const messageIds = collectMessageIds(uc);
  let newest: ComposeSnapshotIndexEntry | undefined;
  for (const entry of Object.values(entriesBySessionId)) {
    if (liveSessionIds[entry.sessionId]) {
      continue;
    }
    const matches =
      (entry.draftId !== undefined && draftIds.has(entry.draftId)) ||
      (entry.sourceMessageId !== undefined &&
        messageIds.has(entry.sourceMessageId));
    if (matches && (!newest || entry.updatedAt > newest.updatedAt)) {
      newest = entry;
    }
  }
  return newest;
};
